import { GridSortModel, GridSortDirection, GridFilterModel, GridLinkOperator } from "@mui/x-data-grid-pro";

export const parseSortModel = (sortStr: string): GridSortModel => {
  return sortStr
    .split(",")
    .map((columnSpecStr) => columnSpecStr.split("+"))
    .map(([column, direction]) => ({
      field: column,
      sort: direction as GridSortDirection,
    }));
};

export const serializeSortModel = (sortModel: GridSortModel): string => {
  return sortModel.map(({ field, sort }) => `${field}+${sort}`).join(",");
};

export type OrderBy = "asc" | "desc" | "asc_nulls_first" | "asc_nulls_last" | "desc_nulls_first" | "desc_nulls_last";

export const parseFilterModelFromSearchParams = (searchParams: URLSearchParams): GridFilterModel | undefined => {
  const filterStr = searchParams.get("filter") || "";
  if (!filterStr) {
    return undefined;
  }

  const filterOperator: GridLinkOperator =
    (searchParams.get("filterOperator") as GridLinkOperator) || GridLinkOperator.And;

  return {
    items: filterStr
      .split(",")
      .map((columnSpecStr) => columnSpecStr.split(":"))
      .map(([id, columnField, operatorValue, value]) => ({
        id,
        columnField,
        operatorValue,
        value,
      })),
    linkOperator: filterOperator,
  };
};

/**
 * Serializes a filter model to a URLSearchParams object, extending existing search params if provided.
 * Does not modify the existing search params object, but returns a new one.
 * @param filterModel The filter model to serialize
 * @param existingParams Existing search parameters, if any
 * @returns A URLSearchParams object
 */
export const filterModelToSearchParams = (
  filterModel: GridFilterModel,
  existingParams?: URLSearchParams,
): URLSearchParams => {
  const params = existingParams ? new URLSearchParams(existingParams) : new URLSearchParams();

  if (filterModel.items.length === 0) {
    params.delete("filter");
    params.delete("filterOperator");
    return params;
  }

  params.set(
    "filter",
    filterModel.items
      .map(({ id, columnField, operatorValue, value }) => `${id}:${columnField}:${operatorValue}:${value}`)
      .join(","),
  );
  params.set("filterOperator", filterModel.linkOperator || "and");

  return params;
};
